import { Box, Typography } from "@mui/material";
import React, { FC } from "react";

const CompanyGroup: FC<{
  title: string;
  companyCount: number;
  children: React.ReactNode;
}> = ({ title, companyCount, children }) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: 4,
        boxShadow: 1,
        padding: 2.5,
        flex: { xs: "1 0 100%", md: `1 0 ${companyCount * 250}px` },
        maxWidth: "100%",
      }}
    >
      <Box mb={2}>
        <Typography variant="h5" style={{ fontWeight: 700 }}>
          {title}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        sx={{
          rowGap: 8,
          columnGap: 4,
          flexWrap: { xs: "wrap", lg: "nowrap" },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default CompanyGroup;
